






































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
    Interaction
---------------------------------------- */

import { Opening } from '@js/module/Opening';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('cases');

/* ----------------------------------------
    Transitions Scale
---------------------------------------- */

const scaleIn = el => {
    anime({
        targets: el,
        scale: [1, 1.075],
        duration: 450,
        easing: 'easeOutQuad'
    });
};

const scaleOut = el => {
    anime({
        targets: el,
        scale: [1.075, 1],
        duration: 550,
        easing: 'easeOutBack'
    });
};

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        id: Number
    },

    computed: {
        project() {
            return module.getters('getCaseById', this.id || 1)
        },

        disciplines() {
            return this.project.disciplines.join(', ')
        }
    },

    methods: {
        enter: function (e) {
            scaleIn(this.$refs.scale);
        },

        leave: function (e) {
            scaleOut(this.$refs.scale);
        }
    },

    mounted() {
        this.$refs.thumb.addEventListener('mouseenter', this.enter, false);
        this.$refs.thumb.addEventListener('mouseleave', this.leave, false);
    },

    beforeDestroy() {
        this.$refs.thumb.removeEventListener('mouseenter', this.enter, false);
        this.$refs.thumb.removeEventListener('mouseleave', this.leave, false);
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Welcome extends Vue {}

